module.exports = __webpack_public_path__ + "img/faqs-img.65432f77.png";